export default "__VITE_ASSET__B9c9P56I__"